import { Component, OnInit } from '@angular/core';
import { DashboardCustomerKPIService } from '../../../services';
import { EventService } from '../../../services';
import { ChartDataset } from '../../../interfaces/kpis/customer-kpi-totals';

@Component({
  selector: 'dashboard-customer-kpi-urgency',
  templateUrl: './dashboard-customer-kpi-urgency.component.html',
  styleUrls: ['./dashboard-customer-kpi-display.component.scss'],
})
export class DashboardCustomerKPIUrgencyComponent implements OnInit {
  constructor(
    private dashboardKPIService: DashboardCustomerKPIService,
    private eventService: EventService,
  ) {}

  // pass to display component as Input
  metrics: any[];

  async ngOnInit() {
    this.eventService.CustomerKPIRefreshEvent.subscribe(() => {
      this.loadData();
    });
  }

  async loadData() {
    this.metrics = [];
    await this.setUrgencyMetric();
  }

  async setUrgencyMetric() {
    let colours = this.dashboardKPIService.getGradeColours4();

    let datas: ChartDataset[] = [
      {
        label: 'Completed',
        data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
        backgroundColor: 'rgba(66, 164, 245, 1)',
        type: 'line',
      },
      {
        label: 'Urgent Orders <24hrs',
        data: this.dashboardKPIService.completedTotals.map((x) => x.urgent[0]),
        backgroundColor: colours[0],
      },
      {
        label: 'Orders 24-48hrs',
        data: this.dashboardKPIService.completedTotals.map((x) => x.urgent[1]),
        backgroundColor: colours[1],
      },
      {
        label: 'Orders 48-72hrs',
        data: this.dashboardKPIService.completedTotals.map((x) => x.urgent[2]),
        backgroundColor: colours[2],
      },
      {
        label: 'Orders 72hrs+',
        data: this.dashboardKPIService.completedTotals.map((x) => x.urgent[3]),
        backgroundColor: colours[3],
      },
      // { label: "Urgent Orders %", data: this.dashboardKPIService.completedTotals.map(x => {
      //     return x.completedMoves == 0 ? 0 : (x.urgent[0] / x.completedMoves) * 100.0
      // }), backgroundColor: 'rgba(35,47,93, 0.9)', hideInChart: true, isPercentCol: true }
    ];

    // filter out datas with no value
    datas = this.dashboardKPIService.filterZeroData(datas);

    let labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
    let metric = this.dashboardKPIService.getServiceMetricData(
      'Urgent Orders',
      datas,
      labels,
      true,
      this.dashboardKPIService.stackedChartOptions,
    );

    this.metrics.push(metric);
  }
}
